<div class="www-payment-history">
  <section class="container www-payment-history__con">
    <div class="www-payment-history__con__sta">
      <span class="www-payment-history__con__sta__ys"
        >Twój status: <span class="status">{{ user()?.type }}</span></span
      >

      <div class="www-payment-history__con__sta__dis">-{{ user()?.discount }}% zniżki!</div>
    </div>
    @if (user()?.type === 'member') {
      <!-- <p class="www-payment-history__con__info">
        <a (click)="showCommunicat('TODO')">Sprawdź</a>, jaki obrót zrobić, aby zostać ELITE w drugim półroczu!
      </p> -->
    }

    <!-- Filter TO DO -->
    <!-- <form [formGroup]="formGroup" class="www-payment-history__con__filters www-form row">
      <div class="col-12 col-md-3">
        <div class="group">
   <input type="text"
            class="form-control"
            [minDate]="minDate"
            [maxDate]="maxDate"
            #dp="bsDatepicker"
            bsDatepicker [(bsValue)]="myDateValue">
          <label for="dateFrom">Data zamówienia od:</label>
        </div>
      </div>
      <div class="col-12 col-md-3">
        <div class="group">
   <input type="text"
            class="form-control"
            [minDate]="minDate"
            [maxDate]="maxDate"
            #dp="bsDatepicker"
            bsDatepicker [(bsValue)]="myDateValue">
          <label for="dateTo">Data zamówienia do:</label>
        </div>
      </div>
      <div class="col-12 col-md-3">
        <div class="group group--select">
          <ng-select
            [closeOnSelect]="true"
            [dropdownPosition]="'bottom'"
            [formControlName]="'type'"
            [multiple]="false"
            [virtualScroll]="false"
            id="subject"
          >
            <ng-option [value]="'1'"> 1 </ng-option>
            <ng-option [value]="'2'"> 2 </ng-option>
          </ng-select>
          <label for="subject">Rodzaj zamówienia</label>
        </div>
      </div>
      <div class="col-12 col-md-3">
        <button (click)="filter()">Filtruj</button>
      </div>
    </form> -->
    @if (orders()?.data?.length) {
      <div class="www-payment-history__con__table__res">
        <table>
          <thead>
            <tr>
              <th>Nazwa zamówienia</th>
              <th>Data zamówienia</th>
              <th>Koszt</th>
              <th>Bilety</th>
              <th>Akcja</th>
            </tr>
          </thead>
          <tbody>
            @for (o of orders()?.data; track $index) {
              <tr>
                <td>{{ o.training_name }}</td>
                <td>{{ o.created_at | date: 'dd/MM/yyyy HH:mm' }}</td>
                <td>{{ o.total_price ? (o.total_price | mask: 'separator.2') + ' PLN' : 'Szkolenie bezpłatne' }}</td>
                <td>{{ o.tickets }}</td>
                <td><a (click)="openOrderDetailsModal(o)">Szczegóły</a></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    } @else {
      <div class="www-payment-history__con__sta">
        <span class="www-payment-history__con__sta__ys">Brak rezerwacji do wyświetlenia</span>
      </div>
    }

    @if (orders()?.total_pages) {
      <app-paginator [totalPages]="orders()!.total_pages" (onPageChange)="pageChange($event)" />
    }

    @if (user()?.type === UserType.MEMBER) {
      <div class="www-payment-history__con__last-info">
        Po osiągnięciu progu 33 000 zł netto zł awansujesz do statusu ELITE i uzyskasz -20% stałej zniżki!
      </div>
    }
  </section>
</div>
